// CSS Modules - component class name prefix: SocialSharing__

<template>
  <div
    :class="
      isFlyout === true
        ? [$style.isFlyout, { isActive: isActive }]
        : $style.noFlyout
    "
  >
    <div
      :class="$style.button"
      v-if="isFlyout"
      v-on:mouseenter="isActive = true"
      v-on:mouseleave="isActive = false"
      v-on:click="isActive = !isActive"
    >
      <i :class="socialSharingIcon"></i>
    </div>
    <ul
      :class="[$style.container, isFlyout ? '' : 'column']"
      v-on:mouseenter="isActive = true"
      v-on:mouseleave="isActive = false"
    >
      <li
        v-for="(link, index) in socialSharingLinks"
        :key="index"
        :class="link.showDelimiter === true ? $style.prevDelimiter : ''"
      >
        <SocialSharingLink :link="link" :showLabel="isFlyout" />
      </li>
    </ul>
  </div>
</template>

<script>
import SocialSharingLink from "./SocialSharingLink.vue";

export default {
  name: "SocialSharing",
  components: {
    SocialSharingLink
  },
  props: {
    isFlyout: {
      type: Boolean,
      default: false
    },
    socialSharingIcon: {
      type: String,
      default: "fas fa-share-alt"
    },
    socialSharingLinks: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isActive: false
    };
  }
};
</script>

<style module lang="scss">
@import "./SocialSharing.scss";
</style>
